import React, { useEffect, useState } from 'react';
import { Box, Typography, Textarea, Button } from '@mui/joy';

import mockup_1 from '../../resources/rvt-il-1.png'
import mockup_3 from '../../resources/rvt-il-3.png'

export default function RealtimePreview({ type, questionType, message1, message2, message3, items, step, showStepper }: any) {
    const [activeStep, setActiveStep] = useState(1);

    useEffect(() => {
        setActiveStep(step);
    }, [step]);

    return (

        <Box>
            <Box>
                <div className="iphone-frame">
                    <div className="iphone-notch"></div>
                    <div className="screen">
                        <div className='preview bg-cloudie mx-auto'>
                            {/* Step 1 content */}
                            {(activeStep === 1 || activeStep === 2) && (
                                <>
                                    <img
                                        alt='Preview for stage step 1'
                                        className='mt-5'
                                        src={mockup_1}
                                        style={{
                                            maxWidth: '50%',
                                            height: '50px',
                                            objectFit: 'cover',
                                            objectPosition: 'top',
                                        }}
                                    />
                                    <div className='ps-2 pe-2 mt-4'>
                                        <Typography
                                            sx={{
                                                fontSize: '12px'
                                            }}
                                            className='iron regular'>
                                            {message1 || "Hello! 👋 We value your feedback. How was your experience?"}
                                        </Typography>
                                    </div>
                                    {type === 'yn' &&
                                        <div className='mt-3'>

                                            <Typography
                                                sx={{
                                                    fontWeight: 'bold',
                                                    fontSize: '10px'
                                                }}>
                                                Are you enjoying?
                                            </Typography>
                                            <div
                                                className='row justify-content-center mt-2'>
                                                <div className='col-auto'>
                                                    <Typography
                                                        sx={{
                                                            fontSize: '24px'
                                                        }}>
                                                        👍
                                                    </Typography>
                                                </div>
                                                <div className='col-auto'>
                                                    <Typography
                                                        sx={{
                                                            fontSize: '24px'
                                                        }}>
                                                        👎
                                                    </Typography>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    {type === 'rating' &&
                                        <div className='mt-1 text-center bg-cloudie pt-3 pb-3'>
                                            <div className='row px-5 text-center'>
                                                {["🤬", "🙁", "😐", "🙂", "😄"].map((star) => (
                                                    <div
                                                        key={star}
                                                        className='col text-center px-0'>
                                                        <div>{star}</div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    }
                                </>
                            )}

                            {/* Step 2 content */}
                            {activeStep === 3 && (
                                <>
                                    <div className='ps-2 pe-2 mt-5'>
                                        <Typography
                                            sx={{
                                                fontSize: '12px'
                                            }}>
                                            {message2 || "Sorry to hear that. Could you tell us more?"}
                                        </Typography>
                                    </div>
                                    <div>
                                        <div className='mt-3 mb-3 px-3' style={{
                                            display: 'flex',
                                            flexWrap: 'wrap',
                                            gap: '4px',
                                            justifyContent: 'flex-start'
                                        }}>
                                            {items.map((question: string, index: number) => (
                                                <>
                                                    {questionType === 1 &&
                                                        <div key={index} className='row text-end'>
                                                            <div className='col'>
                                                                <Typography
                                                                    sx={{
                                                                        fontSize: '8px',
                                                                        fontWeight: 'bold'
                                                                    }}
                                                                    className='iron legend m-1'>
                                                                    {question}
                                                                </Typography>
                                                            </div>
                                                            <div className='col-auto'>
                                                                <div
                                                                    style={{ width: '16px', height: '16px' }}
                                                                    className='check'></div>
                                                            </div>
                                                        </div>}
                                                    {questionType === 2 &&
                                                        <div
                                                            key={index}
                                                            className='inline-block'>
                                                            <div className='px-2 py-1 rounded-pill text-center text-white'
                                                                style={{
                                                                    fontSize: '8px',
                                                                    fontWeight: 'bold',
                                                                    display: 'inline-block',
                                                                    minWidth: 'fit-content',
                                                                    whiteSpace: 'nowrap',
                                                                    backgroundColor: '#3A86FF',
                                                                }}>
                                                                {question}
                                                            </div>
                                                        </div>}
                                                </>
                                            ))}
                                        </div>
                                        <div className='px-3 py-2'>
                                            <Textarea
                                                className="form-control"
                                                id="recipient-name"
                                                size="lg"
                                                sx={{ fontSize: '8px' }}
                                                placeholder="Type your feedback...">
                                            </Textarea>
                                        </div>
                                    </div>
                                    <div className=''>
                                        <div className='mx-auto bg-greenie preview-btn'>
                                            <Typography
                                                sx={{
                                                    fontSize: '10px',
                                                    fontWeight: 'bold'
                                                }}
                                                className='text-white mt-3 mb-2 p-1'>
                                                Send
                                            </Typography>
                                        </div>
                                        <div className='mx-auto preview-btn'>
                                            <Typography
                                                sx={{
                                                    fontSize: '10px',
                                                    fontWeight: 'bold'
                                                }}
                                                className='bold iron m-0'>
                                                Not now
                                            </Typography>
                                        </div>
                                    </div>
                                </>
                            )}

                            {/* Step 3 content */}
                            {activeStep === 4 && (
                                <>
                                    <img
                                        alt='Preview for stage step 3'
                                        className='mt-5'
                                        src={mockup_3}
                                        style={{
                                            maxWidth: '50%',
                                            height: '50px',
                                            objectFit: 'cover',
                                            objectPosition: 'top',
                                        }}
                                    />
                                    <div className='ps-2 pe-2 mt-4'>
                                        <Typography
                                            sx={{
                                                fontSize: '12px'
                                            }}
                                            className='iron regular'>
                                            {message3 || "Thank you for your feedback!"}
                                        </Typography>
                                    </div>
                                    <div className='mx-auto preview-btn bg-greenie mt-5'>
                                        <Typography
                                            sx={{
                                                fontSize: '10px',
                                                fontWeight: 'bold'
                                            }}
                                            className='text-white mt-3 mb-2 p-1'>
                                            Close
                                        </Typography>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </Box >
            {showStepper && (
                <div className='justify-content-center text-center mt-3'>
                    <div className='d-flex gap-2 justify-content-center'>
                        <Button
                            size="sm"
                            variant={activeStep === 1 || activeStep === 2 ? "solid" : "outlined"}
                            color="primary"
                            sx={{ fontSize: '10px', fontWeight: 'bold' }}
                            onClick={() => setActiveStep(1)}
                        >
                            1
                        </Button>

                        <Button
                            size="sm"
                            variant={activeStep === 3 ? "solid" : "outlined"}
                            color="primary"
                            sx={{ fontSize: '10px', fontWeight: 'bold' }}
                            onClick={() => setActiveStep(3)}
                        >
                            2
                        </Button>

                        <Button
                            size="sm"
                            variant={activeStep === 4 ? "solid" : "outlined"}
                            color="primary"
                            sx={{ fontSize: '10px', fontWeight: 'bold' }}
                            onClick={() => setActiveStep(4)}
                        >
                            3
                        </Button>
                    </div>
                </div>
            )}
        </Box >
    );
}